import {
  LessonContent,
  LessonNavItem,
  LessonNavSubItem,
  LessonPageGroup,
  LessonPageIcon,
  LessonPageLinkType,
} from '../types/lessons';
import {
  Arrow,
  Assessment,
  At,
  Beyond,
  Document,
  Exemplar,
  Flexible,
  IWP,
  Star,
  Towards,
  Video,
} from '../assets/icons/Lesson';

export const computeNavItems = (content: LessonContent['content']): LessonNavItem[] => {
  return content.reduce(
    (navItems: LessonNavItem[], pageGroup: LessonPageGroup) => [
      ...navItems,
      {
        title: pageGroup.title,
        items: pageGroup.content.reduce(
          (subItems: LessonNavSubItem[], page) => [
            ...subItems,
            {
              id: page.id,
              title: page.title,
            },
          ],
          []
        ),
      },
    ],
    []
  );
};

// eslint-disable-next-line complexity
export const getLessonIcon = (iconKey: string, color?: string): JSX.Element => {
  switch (iconKey) {
    case LessonPageIcon.checkIn:
    case LessonPageIcon.assessment:
      return Assessment(color);
    case LessonPageIcon.flexible:
      return Flexible(color);
    case LessonPageIcon.star:
      return Star();
    case LessonPageIcon.T:
      return Towards();
    case LessonPageIcon.A:
      return At();
    case LessonPageIcon.B:
      return Beyond();
    case LessonPageLinkType.document:
      return Document();
    case LessonPageLinkType.exemplar:
      return Exemplar(color);
    case LessonPageLinkType.iwp:
      return IWP();
    case LessonPageLinkType.video:
      return Video(color);
    case 'arrow':
      return Arrow();
    default:
      return Document();
  }
};

export const getLessonIconTooltipContent = (iconKey: string): string => {
  switch (iconKey) {
    case LessonPageIcon.checkIn:
    case LessonPageIcon.assessment:
      return "Complete assessment\n\n to evaluate students'\n\n understanding";
    case LessonPageIcon.flexible:
      return 'Suitable for whole-class \n\n if deemed ready, or use \n\n with Beyond students only';
    case LessonPageIcon.T:
      return 'Working towards achieving\n\n the Success Criteria, with\n\n additional teacher intervention';
    case LessonPageIcon.A:
      return 'Expected to achieve\n\n the Success Criteria,\n\n working at year level';
    case LessonPageIcon.B:
      return 'Expected to achieve the\n\n Success Criteria, ready\n\n to work beyond year level';
    default:
      return '';
  }
};
